import React from 'react'
import PropTypes from 'prop-types'
import { Pane, Text, Flex, Button } from '@leverege/ui-elements'

import style from './style.css'

export default class GeotileThumbnail extends React.Component {
  static propTypes = {
    onClick : PropTypes.func.isRequired,
    onDelete : PropTypes.func.isRequired,
    geotile : PropTypes.object.isRequired
  }

  onClick = ( e ) => {
    const { geotile, onClick } = this.props
    onClick( geotile )
  }

  onDelete = ( e ) => {
    const { geotile, onDelete } = this.props
    onDelete( geotile )
  }

  render() {
    const { geotile, onDelete } = this.props
    const { id, sourceImagePath, name } = geotile
    return (
      <Pane onClick={this.onClick} className={style.geotileThumbnail} variant="thumbnail">
        <Pane variant="thumbnailTop" className={style.thumbnailImage}>
          {sourceImagePath && <img src={sourceImagePath} />}
        </Pane>
        <Pane variant="thumbnailBottom">
          <div className={style.geotileThumbnailBottom}>
            <Text className={style.geotileThumbnailTitle} variant="cardTitle">{name || id}</Text>
            <Text className={style.geotileThumbnailSubtitle} variant="caption">{name ? id : ''}</Text>
            <Button className={style.delete} variant="linkDestructive" onClick={this.onDelete}><i className="fa fa-trash" /></Button>
          </div>
        </Pane>
      </Pane>
    )
  }
}
